import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import {Response} from '@angular/http';
import {AdminService} from '../../../services/admin.service';
import {FullUser} from '../../../models/full-user.model';
import {NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {Schedule} from '../../../models/schedule.model';
import {TimeFormatterService} from '../../../services/time-formatter.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css']
})
export class CreateUserComponent implements OnInit {
  confPass = '';
  originPass = '';

  startedConfirmPass = false;
  passNoMath = true;
  passMath = false;
  disableRegBtn = false;
  userExist = false;
  private fullUser: FullUser;
  successInfo = false;
  errorInfo = false;
  errorGetDataListInfo = false;
  errorValidationInfo = false;

  selectedRole = 'USER';
  selectedTesting = 'ENABLE_TESTING';
  private testingForm = true;

  // remove if it is for css
  yesTestingStatus = true;
  noTestingStatus = false;

  selectedAccess = 'DISABLE_REMOTE_ACCESS';
  private remoteAccessForm = false;

  // remove if it is for css
  noAccessStatus = true;
  yesAccessStatus = false;

  selectedLanguage = 'RUSSIAN';
  selectedSchedule = 'Select';
  schedule: Schedule = null;
  private scheduleForm = null;

  selectedStatus = 'ACTIVE';
  internalNumber: string;

  familiarizationDays: number;

  // for css
  activeStatus = true;
  inactiveStatus = false;

  selectedGroup = 'Select';
  private groupIDForm = null;

  selectedPosition = 'Select';
  private positionForm = null;

  public dateOfEmployment: NgbDateStruct;

  groupList: any;
  schedulesList: any[] = [];
  schedulesListNoFormat: any;
  // positionList: any[];

  public isAdmin = false;
  public isHead = false;
  public isPartner = false;
  public isUser = true;

  public formGroup: FormGroup;

  public allPositions;

  constructor(private adminService: AdminService,
              public parserFormatter: NgbDateParserFormatter,
              private formatService: TimeFormatterService,
              private router: Router) {
  }

  ngOnInit() {
    this.formGroup = new FormGroup({
      Login: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.pattern(/^[a-zA-Z0-9_.-]*$/)
      ]),
      Password: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
        Validators.pattern(/^[a-zA-Z0-9_.-]*$/)
      ]),
      FirstName: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern(/^[a-zA-Z.'-]*$/)
      ]),
      LastName: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern(/^[a-zA-Z.'-]*$/)
      ]),
      Email: new FormControl('', [
        Validators.pattern(
          /^[-a-z0-9!#$%&'*+/=?^_`{|}~]+(\.[-a-z0-9!#$%&'*+/=?^_`{|}~]+)*@([a-z0-9]([-a-z0-9]{0,61}[a-z0-9])?\.)*(aero|arpa|asia|biz|cat|com|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel|[a-z][a-z])$/)
      ]),
      InternalNumber: new FormControl(''),
      PatronymicName: new FormControl(''),
      Phone: new FormControl(''),
      FamDays: new FormControl(null)
    });


    // get active positions
    this.adminService.getActivePositions().subscribe(
      (res: any) => {
        this.allPositions = res.body;
        // this.selectedPosition = this.allPositions[0].name;
        // this.positionForm = this.allPositions[0].id;
        this.selectedPos(this.allPositions[0].id, this.allPositions[0].name);
      },
      () => {
      }
    );

    // get groups
    this.adminService.getAllGroups().subscribe(
      (response) => {
        this.groupList = response.body;
      },
      () => {
        this.errorGetDataListInfo = true;
      },
      () => {
        this.selectedGro(this.groupList[0]);
        // this.selectedPos(this.allPositions[0].id, this.allPositions[0].name);

      }
    );

    const date = new Date();
    this.dateOfEmployment = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };

    // get schedules
    this.adminService.getSchedules().subscribe(
      (response) => {
        this.schedulesListNoFormat = response.body;
      },
      () => {
        this.errorGetDataListInfo = true;
      },
      () => {
        // Format time;
        // this.schedulesListNoFormat.forEach(item => {
        //   this.schedulesList.push(this.formatService.formatTime(item));
        // });
        this.selectNullSchedule();
      }
    );
  }

  confirmPasswordCheck() {
    if (!this.startedConfirmPass) {
      this.startedConfirmPass = true;
    }

    if (this.formGroup.get('Password').value === this.confPass) {
      this.passMath = true;
      this.passNoMath = false;
    } else {
      this.passMath = false;
      this.passNoMath = true;
    }
  }


  passIsOk() {
      return this.formGroup.get('Password').value === this.confPass && this.confPass.length > 0;
  }


  selectRole(role) {
    if (role === 'ADMIN') {
      this.isAdmin = true;
      this.isHead = false;
      this.isPartner = false;
      this.isUser = false;
    }
    if (role === 'HEAD') {
      this.isAdmin = false;
      this.isHead = true;
      this.isPartner = false;
      this.isUser = false;
    }
    if (role === 'PARTNER') {
      this.isAdmin = false;
      this.isHead = false;
      this.isPartner = true;
      this.isUser = false;
      this.selectedRemouteAccess('ALLOW_REMOTE_ACCESS');
    }
    if (role === 'USER') {
      this.isAdmin = false;
      this.isHead = false;
      this.isPartner = false;
      this.isUser = true;
      this.selectedRemouteAccess('DISABLE_REMOTE_ACCESS');
    }
    this.selectedRole = role;
  }


  selectedTest(testing) {
    if (testing === 'DISABLE_TESTING') {
      this.yesTestingStatus = false;
      this.noTestingStatus = true;
    } else {
      this.yesTestingStatus = true;
      this.noTestingStatus = false;
    }

    this.selectedTesting = testing;
  }

  selectedRemouteAccess(access) {
    if (access === 'DISABLE_REMOTE_ACCESS') {
      this.yesAccessStatus = false;
      this.noAccessStatus = true;
    } else {
      this.yesAccessStatus = true;
      this.noAccessStatus = false;
    }
    this.selectedAccess = access;
  }

  selectedLang(language) {
    this.selectedLanguage = language;
  }

  selectedSched(schedule: Schedule) {
    this.selectedSchedule =
      schedule.workStart + ' - ' + schedule.workEnd;
    this.schedule = schedule;
  }

  selectedStat(status) {
    if (status === 'ACTIVE') {
      this.activeStatus = true;
      this.inactiveStatus = false;
    } else {
      this.activeStatus = false;
      this.inactiveStatus = true;
    }
    this.selectedStatus = status;
  }

  selectedGro(group) {
    // this.selectedPosition = 'Select';
    // this.positionForm = null;
    this.selectedGroup = group.name; // group.name
    this.groupIDForm = group.id; // * group.id
    // this.positionList = positions; // * group.positions

    // this.selectedPos(this.allPositions[0].id, this.allPositions[0].name);
  }

  selectedPos(id, posTitle) {
    this.selectedPosition = posTitle;
    this.positionForm = id;
  }

  selectNullSchedule() {
    this.selectedSchedule = 'NOT_ASSIGNED';
    this.schedule = null;
  }

  formValidte() {
    // hide all notifications
    this.successInfo = false;
    this.errorInfo = false;
    this.errorGetDataListInfo = false;
    this.errorValidationInfo = false;

    // required fields

    // from buttons
    // testing
    this.testingForm = this.selectedTesting === 'DISABLE_TESTING';
    // access
    this.remoteAccessForm = this.selectedAccess !== 'DISABLE_REMOTE_ACCESS';
    // schedule
    if (this.scheduleForm === null) {
      this.errorValidationInfo = true;
      return false;
    }
    // position
    if (this.positionForm === null) {
      this.errorValidationInfo = true;
      return false;
    }
    return true;
  }


  onSubmit() {
    this.errorValidationInfo = false;

    this.disableRegBtn = true;
    this.successInfo = false;
    this.errorInfo = false;
    this.userExist = false;

    // testing
    this.testingForm = this.selectedTesting === 'DISABLE_TESTING';
    // access
    this.remoteAccessForm = this.selectedAccess !== 'DISABLE_REMOTE_ACCESS';


    if (this.passIsOk()) {
      this.fullUser = new FullUser(  
        this.formGroup.get('Login').value,
        this.formGroup.get('Password').value,
        this.formGroup.get('FirstName').value,
        this.formGroup.get('LastName').value,
        this.formGroup.get('PatronymicName').value,
        this.parserFormatter.format(this.dateOfEmployment),
        this.selectedLanguage,
        [
          this.selectedRole
        ],
        this.schedule != null ? {id: this.schedule.id} : null,
        this.selectedStatus,
        this.formGroup.get('InternalNumber').value,
        this.remoteAccessForm,
        this.formGroup.get('Phone').value,
        this.formGroup.get('Email').value !== '' ? this.formGroup.get('Email').value : null,
   
        this.testingForm,
        this.groupIDForm,
        this.formGroup.get('FamDays').value !== '' ? this.formGroup.get('FamDays').value : null,
        this.formGroup.get('statusDate').value
      );

      const groupObj = {
        'id': this.groupIDForm
      };

      const positionObj = {
        'id': this.positionForm
      };

      this.adminService.createFullUser(this.fullUser, groupObj, positionObj).subscribe(
        (response: any) => {
          if (response.status === 201) {
            this.successInfo = true;
            this.errorInfo = false;
            this.disableRegBtn = false;
            this.userExist = false;
            this.formGroup.reset();
            this.confPass = '';
            this.router.navigate(['/dashboard/admin/users']);
          }
        },
        (error) => {
          if (error.status === 412) {
            this.successInfo = false;
            this.errorInfo = false;
            this.userExist = true;
            this.disableRegBtn = false;
          } else {
            this.successInfo = false;
            this.errorInfo = true;
            this.disableRegBtn = false;
            this.userExist = false;
          }
        }
      );

    } else {
      this.errorValidationInfo = true;
      this.startedConfirmPass = true;
      this.passNoMath = true;
      this.passMath = false;
      this.userExist = false;
      this.disableRegBtn = false;
    }
  }

  filterBy(prop: string, list: string) {
    if (list === 'departments') {
      if (this.groupList !== undefined) {
        return this.groupList.sort((a, b) => a[prop].toLowerCase() > b[prop].toLowerCase() ? 1 : a[prop].toLowerCase() === b[prop].toLowerCase() ? 0 : -1);
      }
    }
    if (list === 'positions') {
      if (this.allPositions !== undefined) {
        return this.allPositions.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
      }
    }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
}




// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-user/create-user.component.ts